import React from "react";
import HomeNavBar2 from "../Components/HomeNavBar/HomeNavBar2";
import Footer from "../Components/Footer/Footer";

const ArticlesPage = () => {
  return (
    <div>
      <HomeNavBar2/>
      <Footer/>
    </div>
  );
};

export default ArticlesPage;